import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ImageUpload } from "@/components/site/ImageUpload";

export default function EssapAdmin() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/essap").then((r) => setF({ logo: r.data.logo, contenu: r.data.contenu })).catch(() => setF({ logo: null, contenu: "" })); }, []);

  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/essap", f); toast.success("Page ESSAP enregistrée"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">ESSAP · Présentation</h1>
          <p className="text-slate-500 mt-1">Logo et informations essentielles sur la constitution de l'ESSAP.</p>
        </div>
        <Link to="/essap" target="_blank" className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-800"><ExternalLink className="h-4 w-4" /> Voir la page publique</Link>
      </div>
      {f === null ? <Loader2 className="h-8 w-8 animate-spin text-emerald-700" /> : (
        <div className="rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-6">
          <div className="space-y-1.5">
            <Label>Logo de l'ESSAP</Label>
            <div className="w-40"><ImageUpload value={f.logo} onChange={(v) => setF({ ...f, logo: v })} testId="essap-logo-upload" label="Téléverser le logo" /></div>
          </div>
          <div className="space-y-1.5">
            <Label>Texte de la page</Label>
            <Textarea rows={20} data-testid="essap-admin-textarea" value={f.contenu} onChange={(e) => setF({ ...f, contenu: e.target.value })} placeholder="Présentation, constitution, filières, adresse, contacts…" className="leading-relaxed" />
          </div>
          <Button onClick={save} disabled={busy} className="rounded-full" data-testid="essap-admin-save">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Enregistrer</Button>
        </div>
      )}
    </div>
  );
}
